import React, { useContext } from "react";
import { Link } from "react-router-dom";
import Context from "../../Context";
import FamStaff from "../Misc/Fam/FamStaff";
export default function UserNav(props) {
  const cx = useContext(Context);
  let iconClass = "primary";
  if (cx.notifier.task.enabled) iconClass = "warning";
  if (cx.notifier.task.expired) iconClass = "danger";
  return (
    <div className="navi navi-spacer-x-0 p-0">
      <FamStaff
        className="mb-4 text-hover-primary"
        onClick={() => props.toggleFunction()}
        showUnfam
      />
      <Link
        onClick={() => props.toggleFunction()}
        to="/tasks/current/"
        className="navi-item"
      >
        <div className="navi-link">
          <div className="symbol symbol-40 bg-light mr-3">
            <div className="symbol-label">
              <span className={`svg-icon svg-icon-md svg-icon-${iconClass}`}>
                <svg
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  version="1.1"
                >
                  <g
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                  >
                    <rect x="0" y="0" width="24" height="24" />
                    <path
                      d="M2.56066017,10.6819805 L4.68198052,8.56066017 C5.26776695,7.97487373 6.21751442,7.97487373 6.80330086,8.56066017 L8.9246212,10.6819805 C9.51040764,11.267767 9.51040764,12.2175144 8.9246212,12.8033009 L6.80330086,14.9246212 C6.21751442,15.5104076 5.26776695,15.5104076 4.68198052,14.9246212 L2.56066017,12.8033009 C1.97487373,12.2175144 1.97487373,11.267767 2.56066017,10.6819805 Z M14.5606602,10.6819805 L16.6819805,8.56066017 C17.267767,7.97487373 18.2175144,7.97487373 18.8033009,8.56066017 L20.9246212,10.6819805 C21.5104076,11.267767 21.5104076,12.2175144 20.9246212,12.8033009 L18.8033009,14.9246212 C18.2175144,15.5104076 17.267767,15.5104076 16.6819805,14.9246212 L14.5606602,12.8033009 C13.9748737,12.2175144 13.9748737,11.267767 14.5606602,10.6819805 Z"
                      fill="#000000"
                      opacity="0.3"
                    />
                    <path
                      d="M8.56066017,16.6819805 L10.6819805,14.5606602 C11.267767,13.9748737 12.2175144,13.9748737 12.8033009,14.5606602 L14.9246212,16.6819805 C15.5104076,17.267767 15.5104076,18.2175144 14.9246212,18.8033009 L12.8033009,20.9246212 C12.2175144,21.5104076 11.267767,21.5104076 10.6819805,20.9246212 L8.56066017,18.8033009 C7.97487373,18.2175144 7.97487373,17.267767 8.56066017,16.6819805 Z M8.56066017,4.68198052 L10.6819805,2.56066017 C11.267767,1.97487373 12.2175144,1.97487373 12.8033009,2.56066017 L14.9246212,4.68198052 C15.5104076,5.26776695 15.5104076,6.21751442 14.9246212,6.80330086 L12.8033009,8.9246212 C12.2175144,9.51040764 11.267767,9.51040764 10.6819805,8.9246212 L8.56066017,6.80330086 C7.97487373,6.21751442 7.97487373,5.26776695 8.56066017,4.68198052 Z"
                      fill="#000000"
                    />
                  </g>
                </svg>
              </span>
            </div>
          </div>
          <div className="navi-text">
            <div className="font-weight-bold">Планировщик задач</div>
            <div className="text-muted">
              {cx.notifier.task.enabled ? (
                <span className="mr-2">
                  Текущие: {cx.notifier.task.enabled}{" "}
                </span>
              ) : null}
              {cx.notifier.task.expired ? (
                <span className="label label-light-danger label-inline font-weight-bold">
                  {cx.notifier.task.expired} пропущено
                </span>
              ) : null}
            </div>
          </div>
        </div>
      </Link>

      <Link
        to={`/notice/${
          cx.notifier.notice.interfere ? "interfere" : "current"
        }/`}
        className="navi-item"
        onClick={() => props.toggleFunction()}
      >
        <div className="navi-link">
          <div className="symbol symbol-40 bg-light mr-3">
            <div className="symbol-label">
              <span className="svg-icon svg-icon-md svg-icon-success">
                <svg
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  version="1.1"
                >
                  <g
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                  >
                    <path
                      d="M17,12 L18.5,12 C19.3284271,12 20,12.6715729 20,13.5 C20,14.3284271 19.3284271,15 18.5,15 L5.5,15 C4.67157288,15 4,14.3284271 4,13.5 C4,12.6715729 4.67157288,12 5.5,12 L7,12 L7.5582739,6.97553494 C7.80974924,4.71225688 9.72279394,3 12,3 C14.2772061,3 16.1902508,4.71225688 16.4417261,6.97553494 L17,12 Z"
                      fill="#000000"
                    />
                    <rect
                      fill="#000000"
                      opacity="0.3"
                      x="10"
                      y="16"
                      width="4"
                      height="4"
                      rx="2"
                    />
                  </g>
                </svg>
              </span>
            </div>
          </div>
          <div className="navi-text">
            <div className="font-weight-bold">Уведомления</div>
            {cx.notifier.notice.notice ? (
              <span className="text-muted mr-2">
                Новые: {cx.notifier.notice.notice}
              </span>
            ) : null}
            {cx.notifier.notice.interfere ? (
              <span className="label label-light-danger label-inline font-weight-bold">
                {cx.notifier.notice.interfere} требуют внимания
              </span>
            ) : null}
          </div>
        </div>
      </Link>
      {/*
      <a href="/chat/" className="navi-item">
        <div className="navi-link">
          <div className="symbol symbol-40 bg-light mr-3">
            <div className="symbol-label">
              <span className="svg-icon svg-icon-md svg-icon-success">
                <svg
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  version="1.1"
                >
                  <g
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                  >
                    <rect x="0" y="0" width="24" height="24"></rect>
                    <path
                      d="M16,15.6315789 L16,12 C16,10.3431458 14.6568542,9 13,9 L6.16183229,9 L6.16183229,5.52631579 C6.16183229,4.13107011 7.29290239,3 8.68814808,3 L20.4776218,3 C21.8728674,3 23.0039375,4.13107011 23.0039375,5.52631579 L23.0039375,13.1052632 L23.0206157,17.786793 C23.0215995,18.0629336 22.7985408,18.2875874 22.5224001,18.2885711 C22.3891754,18.2890457 22.2612702,18.2363324 22.1670655,18.1421277 L19.6565168,15.6315789 L16,15.6315789 Z"
                      fill="#000000"
                    ></path>
                    <path
                      d="M1.98505595,18 L1.98505595,13 C1.98505595,11.8954305 2.88048645,11 3.98505595,11 L11.9850559,11 C13.0896254,11 13.9850559,11.8954305 13.9850559,13 L13.9850559,18 C13.9850559,19.1045695 13.0896254,20 11.9850559,20 L4.10078614,20 L2.85693427,21.1905292 C2.65744295,21.3814685 2.34093638,21.3745358 2.14999706,21.1750444 C2.06092565,21.0819836 2.01120804,20.958136 2.01120804,20.8293182 L2.01120804,18.32426 C1.99400175,18.2187196 1.98505595,18.1104045 1.98505595,18 Z M6.5,14 C6.22385763,14 6,14.2238576 6,14.5 C6,14.7761424 6.22385763,15 6.5,15 L11.5,15 C11.7761424,15 12,14.7761424 12,14.5 C12,14.2238576 11.7761424,14 11.5,14 L6.5,14 Z M9.5,16 C9.22385763,16 9,16.2238576 9,16.5 C9,16.7761424 9.22385763,17 9.5,17 L11.5,17 C11.7761424,17 12,16.7761424 12,16.5 C12,16.2238576 11.7761424,16 11.5,16 L9.5,16 Z"
                      fill="#000000"
                      opacity="0.3"
                    ></path>
                  </g>
                </svg>
              </span>
            </div>
          </div>
          <div className="navi-text">
            <div className="font-weight-bold">Личные сообщения</div>
            <div className="text-muted">Нет непрочитанных сообщений</div>
          </div>
        </div>
</a>*/}

      {!props.hideWorkdoc && (
        <Link
          to="/workdoc/"
          className="navi-item"
          onClick={() => props.toggleFunction()}
        >
          <div className="navi-link">
            <div className="symbol symbol-40 bg-light mr-3">
              <div className="symbol-label">
                <span className="svg-icon svg-icon-md svg-icon-primary">
                  <svg
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    version="1.1"
                  >
                    <g
                      stroke="none"
                      strokeWidth="1"
                      fill="none"
                      fillRule="evenodd"
                    >
                      <rect x="0" y="0" width="24" height="24" />
                      <path
                        d="M6,2 L18,2 C18.5522847,2 19,2.44771525 19,3 L19,12 C19,12.5522847 18.5522847,13 18,13 L6,13 C5.44771525,13 5,12.5522847 5,12 L5,3 C5,2.44771525 5.44771525,2 6,2 Z M7.5,5 C7.22385763,5 7,5.22385763 7,5.5 C7,5.77614237 7.22385763,6 7.5,6 L13.5,6 C13.7761424,6 14,5.77614237 14,5.5 C14,5.22385763 13.7761424,5 13.5,5 L7.5,5 Z M7.5,7 C7.22385763,7 7,7.22385763 7,7.5 C7,7.77614237 7.22385763,8 7.5,8 L10.5,8 C10.7761424,8 11,7.77614237 11,7.5 C11,7.22385763 10.7761424,7 10.5,7 L7.5,7 Z"
                        fill="#000000"
                        opacity="0.3"
                      />
                      <path
                        d="M3.79274528,6.57253826 L12,12.5 L20.2072547,6.57253826 C20.4311176,6.4108595 20.7436609,6.46126971 20.9053396,6.68513259 C20.9668779,6.77033951 21,6.87277228 21,6.97787787 L21,17 C21,18.1045695 20.1045695,19 19,19 L5,19 C3.8954305,19 3,18.1045695 3,17 L3,6.97787787 C3,6.70173549 3.22385763,6.47787787 3.5,6.47787787 C3.60510559,6.47787787 3.70753836,6.51099993 3.79274528,6.57253826 Z"
                        fill="#000000"
                      />
                    </g>
                  </svg>
                </span>
              </div>
            </div>
            <div className="navi-text">
              <div className="font-weight-bold">Рабочая документация</div>
              <div className="text-muted"></div>
            </div>
          </div>
        </Link>
      )}
    </div>
  );
}
